import { EnumsType } from '..';
import SimpleSelect from './SimpleSelect';

export interface SimpleSelectProps {
	name?: string;
	placeholder?: string;
	disabled?: boolean;
	searchEnable?: boolean;

	value?: string | Array<string> | null;
	setValue: React.Dispatch<React.SetStateAction<string|Array<string>>>;

	minSearchLength?: number;
	onSearch?: ( tern: string ) => void;

	options?: EnumsType;
	multiple?: boolean;
	isWait?: boolean;
	defaultOpen?: boolean;
	showClearBtn?: boolean;
};

export default SimpleSelect;
